import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";

import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { PRODUCT_APIs } from "apihandlers/product";

const NewCategory = (props: any) => {
  const { setDashMenu, privileges } = props;

  const insertAboveRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [insertAbove, setInsertAbove] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        searchQry: "",
        driverCode: false,
      };
      const res: any = await PRODUCT_APIs.getProductNewCategories(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
        console.log("Rows List :", list);

        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
          };
        });
        setInsertAbove(list);
      }
    } catch (error) {
      console.error("getCurrencies:", error);
    }
  };

  const onEditRow = (row: any) => {
    let insertAboveName = "";
    if (row.insertAbove) {
      const selectedInsertAbove = insertAbove.find((i) => {
        return i.id === row.insertAbove;
      });
      if (selectedInsertAbove) {
        insertAboveName = selectedInsertAbove.label;
      }
    }
    row.insertAboveName = insertAboveName;
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "productName",
      name: LABELS.NAME,
      width: "35%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "aliasName",
      name: LABELS.ALIAS_NAME,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "insertAbove",
      name: LABELS.INSERT_ABOVE,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "number",
      searchable: true,
    },
    {
      key: "sortOrder",
      name: LABELS.SORTING_ORDER,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "number",
      searchable: true,
    },

    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "5%",
      editable: false,
      sortable: true,
      align: "center",

      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },

    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageNewCategory = () => {
    const productName = (
      document.getElementById("productName") as HTMLInputElement
    ).value.trim();
    const aliasName = (
      document.getElementById("aliasName") as HTMLInputElement
    ).value.trim();
    const sortOrder = (
      document.getElementById("sortOrder") as HTMLInputElement
    ).value.trim();
    const insertAbove = insertAboveRef.current.selectedValue.id;
    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations
    let errors = [];
    if (productName === "") {
      errors.push({
        id: "productName",
        msg:
          "<span class='bold'>" +
          LABELS.NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (aliasName === "") {
      errors.push({
        id: "aliasName",
        msg:
          "<span class='bold'>" +
          LABELS.ALIAS_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (sortOrder === "") {
      errors.push({
        id: "sortOrder",
        msg:
          "<span class='bold'>" +
          LABELS.SORTING_ORDER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!active) {
      errors.push({
        id: "activeStatus",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      productName,
      aliasName,
      activeStatus: selectBtnValue.toString(),
      sortOrder: Number(sortOrder),
      insertAbove,
    };
    console.log("args", args);
    setIsSubmit(true);
    PRODUCT_APIs.manageProductNewCategory(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.NEW_CATEGORY}</li>
        </ul>
        <h4>{TITLES.NEW_CATEGORY}</h4>
        <p>{SUB_TITLES.NEW_CATEGORY}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={"newcategory"}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.NEW_CATEGORY}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.NEW_CATEGORY + ": " + selectedRow.productName
              : "Add " + LABELS.NEW_CATEGORY
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <TxtRow
              id={"productName"}
              type={"text"}
              label={LABELS.NAME}
              required={true}
              defaultValue={selectedRow.productName}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup red">
            <TxtRow
              id={"aliasName"}
              type={"text"}
              label={LABELS.ALIAS_NAME}
              required={true}
              defaultValue={selectedRow.aliasName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"sortOrder"}
              type={"number"}
              label={LABELS.SORTING_ORDER}
              required={true}
              defaultValue={selectedRow.sortOrder}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <label>{LABELS.INSERT_ABOVE}</label>
            <AutoComplete
              list={insertAbove}
              childRef={insertAboveRef}
              defaultValue={
                selectedRow.insertAbove
                  ? {
                      id: selectedRow.insertAbove,
                      label: selectedRow.insertAboveName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup required">
            <label>{LABELS.ACTIVE_STATUS}</label>
            <span className="red">*</span>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className=" flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageNewCategory}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(NewCategory);
